<template>
  <div class="card">
    <div class="card-body p-0">
      <cardHead
        :title="'Otellerim'"
        :key="isSelectCount"
        :buttons="[
           {
            title: (isSelectCount > 0 ? '(' + isSelectCount + ') ' : '') + 'Send to Login Queue',
            icon: 'mdi mdi-layers-off',
            emit: 'sendToLoginQueue',
            class:
              'btn-primary ' +
              (data == null || isSelectCount == 0
                ? 'none'
                : ''),
          },
          {
            title: 'Reflesh',
            icon: 'fas fa-redo-alt',
            emit: 'get',
          },
        ]"
        @get="get"
        @sendToLoginQueue="sendToLoginQueue"
      ></cardHead>
      <load-area v-if="data == null"></load-area>
      <div class="tables rel" v-if="data != null">
        <div
          class="myCheckBox abs"
          style="    top: 47px;
          z-index: 5;
          left: 6px;"
        >
          <input
            type="checkbox"
            class="filled-in"
            v-model="selectAll"
            id="chckMassConfirmableHotels"
          /><label for="chckMassConfirmableHotels"></label>
        </div>
        <dataTable
          :name="'myHotels'"
          ref="agGrid"
          :columnDefs="columnDefs"
          :addContextMenuItem="getContextMenuItems"
          :data="data"
          @cellClicked="clickedCellRezGrid"
        ></dataTable>
      </div>
    </div>
    <customerDetail
      v-if="customerDetailShow != null"
      :setModel="customerDetailShow"
      @close="customerDetailShow = null"
    ></customerDetail>
  </div>
</template>

<script>
import moment from "moment";
import customerDetail from "./../customers/detail/detail.vue";
export default {
  name: "myHotels",
  components: { customerDetail },
  data() {
    return {
      data: null,
      columnDefs: [
         {
          headerName: "",
          width: 55,
          filter: false,
          field: "isSelected",
          sortable: false,
          cellClick: true,
          enableRowGroup: true,
          floatingFilter: false,
          cellRenderer: this.$CheckCellRenderer,
        },
        {
          headerName: "Id",
          field: "Id",
          enableRowGroup: true,
          floatingFilter: true,
          filter: "agTextColumnFilter",
          cellClick: true,
          width: 80,
        },
        {
          headerName: "Name",
          field: "HotelName",
          enableRowGroup: true,
          floatingFilter: true,
          filter: "agTextColumnFilter",
          flex: 1,
          cellClick: true,
          minWidth: 140,
        },
        {
          headerName: "Customer Name",
          field: "CustomerName",
          enableRowGroup: true,
          floatingFilter: true,
          filter: "agTextColumnFilter",
          flex: 1,
          cellClick: true,
          minWidth: 140,
        },
        {
          headerName: "Software",
          field: "softwareName",
          enableRowGroup: true,
          floatingFilter: true,
          filter: "agTextColumnFilter",
          flex: 1,
          cellClick: true,
          minWidth: 140,
        },
        {
          headerName: "LastSyncTime",
          field: "LastSyncTime",
          enableRowGroup: true,
          floatingFilter: true,
          filter: "agTextColumnFilter",
          cellClick: true,
          width: 160,
          valueFormatter: function(params) {
            let diff = new Date().getTimezoneOffset();
            return moment(
              new Date(params.value).setMinutes(
                new Date(params.value).getMinutes() - diff
              )
            ).format("DD.MM.YYYY HH:mm");
          },
        },
        {
          headerName: "Statu",
          width: 110,
          filter: "agTextColumnFilter",
          field: "statu",
          sortable: true,
          cellClick: true,
          enableRowGroup: true,
          cellRenderer: function(e) {
            let clas = "success";
            if (e.value == "Passive") {
              clas = "secondary";
            }
            return (
              '<span class="badge badge-' + clas + '">' + e.value + "</span>"
            );
          },
        },
      ],
      isSelectCount: 0,
      selectAll: false,
      customerDetailShow: null,
      softwares: null,
    };
  },
  created() {
    this.$appAxiosAdmin.get(`Softwares`).then((response) => {
      this.softwares = response.data;
      this.get();
    });
  },
  watch: {
    selectAll() {
      if (!this.selectAll) {
        this.data.forEach((element) => {
          if (element.isSelected) {
            element.isSelected = false;
            this.$refs.agGrid.changeRow("Id", element);
          }
        });
        this.isSelectCount = 0;
        return false;
      }
      let pager = {
        min:
          this.$refs.agGrid.pager.currentPage *
          this.$refs.agGrid.pager.pageSize,
        max:
          (this.$refs.agGrid.pager.currentPage + 1) *
          this.$refs.agGrid.pager.pageSize,
      };
      this.$refs.agGrid.gridApi.forEachNodeAfterFilterAndSort(
        (rowNode, index) => {
          if (index >= pager.min && index < pager.max) {
            this.$refs.agGrid.changeRow("Id", {
              ...rowNode.data,
              isSelected: true,
            });
          }
        }
      );
      this.isSelectCount = this.data.filter((x) => x.isSelected).length;
    },
  },
  methods: {
    get() {
      this.data = null;
      this.$appAxiosAdmin.get(`Hotels/KolayrezHotels`).then((response) => {
        this.data = response.data.map((x) => {
          return {
            ...x,
            isSelected: false,
            softwareName:
              this.softwares.filter((y) => y.Id == x.SoftwareId)[0].Name +
              " (" +
              x.SoftwareId +
              ")",
              statu:x.IsCustomerActive?'Active':'Passive'
          };
        });
      });
    },
    directLogin(item) {
      console.log(item);
      window.open(
        "https://direct.kolayrez.com/#/direct-login/" + item.DirectLoginKey,
        "_blank"
      );
    },
    createServiceAccount(item) {
      this.$appAxiosAdmin
        .get("hotels/" + item.Id + "/CreateServiceAccount")
        .then(() => {
          this.$swal({
            icon: "success",
            title: "Başarılı",
            text: "Servis başarı ile oluşturuldu",
            timer: 2000,
            confirmButtonText: "Tamam",
          });
        })
        .catch((err) => {
          this.$isError(err);
        });
    },
    clickedCellRezGrid(param) {
      console.log("param.data", param.data);
      if (param.colDef.field == "isSelected") {
        this.$refs.agGrid.changeRow("Id", {
          ...param.data,
          isSelected: !param.data.isSelected,
        });
        this.isSelectCount = this.data.filter((x) => x.isSelected).length;
      } else if (param.colDef.field != "Link") {
         this.customerDetailShow = {
            Id: param.data.CustomerID,
            Name: param.data.CustomerName,
          }
      }
    },
    sendToLoginQueue() {
      let ids = [];
      for (
        let index = 0;
        index < this.$refs.agGrid.gridApi.getDisplayedRowCount();
        index++
      ) {
        if (
          this.$refs.agGrid.gridApi.getDisplayedRowAtIndex(index).data
            .isSelected
        ) {
          ids.push(
            this.$refs.agGrid.gridApi.getDisplayedRowAtIndex(index).data.Id
          );
        }
      }
      if (ids.length > 0) {
        this.$swal({
          icon: "question",
          title: "Warning!",
          text: "Are you sure you want to send the selected items to the login queue?",
          showCancelButton: true,
          confirmButtonText: "Yes",
          cancelButtonText: "No",
        }).then((question) => {
          if (question.isConfirmed) {
            this.$appAxiosAdmin
              .post(`Hotels/LoginQueue`, ids)
              .then((response) => {
                const { queued = [], skipped = [], failed = [] } = response.data;
                this.data.forEach((item) => {
                  if (item.isSelected) {
                    item.isSelected = false;
                    this.$refs.agGrid.changeRow("Id", item);
                  }
                });
                this.selectAll = false;
                this.isSelectCount = 0;
                this.$swal({
                  icon: failed.length ? "warning" : "success",
                  title: "Login Queue",
                  html: [
                    "📤 Sent: " + ids.length,
                    queued.length
                      ? '<span style="color:#28a745">✓</span> Queued: ' + queued.length
                      : null,
                    skipped.length
                      ? '<span style="color:#ffc107">⏭</span> Skipped: ' + skipped.length
                      : null,
                    failed.length
                      ? '<span style="color:#dc3545">✗</span> Failed: ' + failed.length
                      : null,
                  ]
                    .filter(Boolean)
                    .join("<br>"),
                  confirmButtonText: "Okey",
                });
              })
              .catch((err) => {
                this.$isError(err);
              });
          }
        });
      }
    },
    getContextMenuItems(params) {
      let result = [
        "copy",
        "export",
        {
          name: "Create Service Account",
          icon: '<i class="mdi mdi-json"></i>',
          action: () => {
            this.createServiceAccount(params.node.data);
          },
        },
        {
          name: "Login Service Account",
          icon: '<i class="mdi mdi-json"></i>',
          action: () => {
            this.loginHotelServiceAccount(params.node.data);
          },
        },
      ];
      return result;
    },
    loginHotelServiceAccount(item) {
      this.$appAxiosAdmin
        .get("hotels/" + item.Id + "/LoginHotelServiceAccount")
        .then(() => {
          this.$swal({
            icon: "success",
            title: "Başarılı",
            text: "Servis başarı ile login olundu!",
            timer: 2000,
            confirmButtonText: "Tamam",
          });
        })
        .catch((err) => {
          this.$isError(err);
        });
    },
  },
};
</script>
